import en from './en.json'
import tw from './tw.json'

export default {
  en,
  'zh-TW': tw
}
